import { Product } from '@interfaces';
import { styled } from '@mui/system';
import { useCallback, useEffect, useState } from 'react';
import Image from 'next/image';
import { ModalImage } from '@components/ModalImage';

const ImageContainer = styled('div')(({ theme, onClick }) => ({
  width: '100%',
  maxWidth: '80%',
  margin: '16px auto',
  minHeight: 150,
  position: 'relative',
  cursor: onClick ? 'pointer' : 'auto',
  [theme.breakpoints.up(768)]: {
    flex: '1 0 50%',
    maxWidth: 'unset',
    span: {
      maxWidth: '80%',
      margin: 'auto !important',
    },
  },
}));

interface ProductImageProps {
  product: Product;
}
const defaultImage = '/assets/images/default.webp';
export function ProductImage({ product }: ProductImageProps) {
  const [imageUrl, setImageUrl] = useState(
    product.imagesUrl?.[0] || defaultImage,
  );
  const [imageModal, setImageModal] = useState(false);

  useEffect(
    function syncronizeImageOnChangeUrl() {
      if (product?.imagesUrl?.[0]) {
        setImageUrl(product?.imagesUrl?.[0]);
      }
    },
    [product?.imagesUrl],
  );

  const handleImageError = useCallback(() => {
    setImageUrl(defaultImage);
  }, []);

  return (
    <>
      <ImageContainer
        onClick={
          imageUrl !== defaultImage ? () => setImageModal(true) : undefined
        }
        role={imageUrl !== defaultImage ? 'button' : undefined}
        aria-label={`Abrir imagen de ${product.name}`}
      >
        <Image
          src={imageUrl}
          layout="fill"
          alt={`Foto ${product.name}`}
          objectFit="contain"
          onError={handleImageError}
          placeholder="blur"
          blurDataURL="/assets/images/default.webp"
        />
      </ImageContainer>
      <ModalImage
        imageModal={imageModal}
        setImageModal={setImageModal}
        imageUrl={imageUrl}
        handleImageError={handleImageError}
        productName={product.name}
        isProduct={true}
      />
    </>
  );
}
